module.exports = __webpack_public_path__ + "static/media/Email-template_background.e0f0394a.jpg";